import React, { useEffect, useState } from "react";
import axios from "axios";
import useScrollToTop from "../../../hooks/useScollToTop";
import DashboardNavigation from "../../DashboardNavigation/DashboardNavigation";
import { useUser } from "../../Home/UserContext";
import { getRoleFromRoleId } from "../../../utils/roleHelper";
import { FaHeart } from "react-icons/fa";

const ProduitsPage = () => {
  useScrollToTop();
  const { user } = useUser();
  const userRole = getRoleFromRoleId(user?.role_id);

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        "https://api.monappliclub.com/api/productsapp/allproductsapp"
      );
      if (Array.isArray(response.data)) {
        // tri par ordre_app croissant
        const sorted = [...response.data].sort(
          (a, b) => a.ordre_app - b.ordre_app
        );
        setProducts(sorted);
      } else {
        throw new Error("Les données reçues ne sont pas valides.");
      }
    } catch (error) {
      console.error("Erreur lors du chargement des produits :", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <div className="flex flex-col w-full mx-auto p-2 mt-[130px] sm:mt-[130px] md:mt-[150px] lg:mt-[150px] xl:mt-[150px] dark:text-white">
      <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-light tracking-[0.4em] text-gray-800 text-center dark:text-white mb-4">
        UTILISATEUR
      </h2>
      <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold tracking-widest text-gray-800 text-center dark:text-white mb-4 font-montserrat uppercase">
        Applications Judo
      </h2>
      <DashboardNavigation role={userRole} />

      <div className="container mx-auto px-4 mb-6 bg-slate-200 dark:bg-slate-800 rounded-lg shadow-md p-6 mt-4">
        <div className="flex flex-col md:flex-row items-center">
          <div className="md:w-1/3 mb-8 md:mb-0">
            <img
              src="https://res.cloudinary.com/dj0c0zuje/image/upload/v1744184384/PXL_20241115_211013575.MP_1_h7lbn9.jpg"
              alt="Victorin Laurent"
              className="rounded-full mx-auto h-64 w-64 object-cover"
            />
          </div>
          <div className="md:w-2/3 md:pl-12 text-center md:text-left">
            <h3 className="text-2xl font-semibold mb-4">Laurent VICTORIN</h3>
            <hr className="border-gray-400 dark:border-gray-700" />
            <p className="text-lg mt-4 font-semibold italic">
              Développeur Web & Web Mobile,
            </p>
            <p className="text-lg font-semibold italic">
              Président & Enseignant de club de Judo,
            </p>
            <p className="text-lg font-semibold italic">
              Membre du Comité Départemental de Judo de la Gironde en charge de
              la communication.
            </p>

            <p className="mt-4">
              🔹 Passionné par le développement web et le judo, j'ai combiné ces
              deux passions pour créer des applications en lien avec le Judo et
              plus généralement les arts martiaux. Mon objectif est de fournir
              aux clubs, enseignants et adhérents des outils adaptés à leurs
              besoins.
              <br />
              🔹 Prenez le temps de découvrir ces applications et n'hésitez pas
              à me contacter pour toute question ou suggestion.
              <br />
              📨 monappliclub@gmail.com ou 📞 0680727707
              <br />
              🔹 En bas de page, vous trouverez un lien si vous souhaitez faire
              un don afin de me soutenir dans le développement de ces
              applications. Merci par avance.
            </p>
            <div className="mt-8">
              <a
                href="https://www.monappliclub.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="px-8 py-3 bg-blue-600 hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 text-white rounded-full transition"
              >
                Mon Site Web
              </a>
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <p className="text-center text-gray-600 dark:text-gray-300">
          Chargement en cours...
        </p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 px-4 md:px-8 max-w-[1400px] mx-auto">
          {products.map((app) => (
            <div
              key={app.id}
              className="bg-white dark:bg-gray-800 shadow-lg rounded-2xl overflow-hidden hover:scale-[1.02] transition duration-300 ease-in-out flex flex-col"
            >
              {app.image_url_app ? (
                <img
                  src={app.image_url_app}
                  alt={app.nom_app}
                  className="w-full h-48 object-contain"
                />
              ) : (
                <div className="w-full h-48 bg-gray-300 dark:bg-gray-600 flex items-center justify-center text-gray-500 italic">
                  Pas d'image
                </div>
              )}

              <div className="p-4 flex flex-col flex-grow">
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">
                  {app.nom_app}
                </h3>
                <p className="text-sm text-gray-700 dark:text-gray-300 flex-grow">
                  {app.description_app || "Description non renseignée."}
                </p>
                {app.lien_url_app && (
                  <a
                    href={app.lien_url_app}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mt-4 inline-block text-center bg-primary text-white py-2 px-4 rounded-full hover:bg-black hover:text-white transition-colors duration-200"
                  >
                    Découvrir / Exemple
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Encart phase de test et dons */}
      <div className="bg-blue-50 dark:bg-gray-800 py-8 px-4 text-center rounded-lg shadow-lg max-w-3xl mx-auto mt-4">
        <h3 className="text-2xl font-bold text-blue-900 dark:text-white">
          Don pour la création d'applications web
        </h3>
        <p className="text-gray-700 dark:text-gray-300 mt-4">
          Votre générosité m'aidera à développer de nouvelles fonctionnalités et
          de nouvelles applications en lien avec votre discipline.
        </p>
        <a
          href="https://buy.stripe.com/cN2aFtaqL5fC1AkcMR"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center px-6 py-3 mt-4 bg-blue-500 hover:bg-blue-600 text-white text-lg font-semibold rounded-full shadow-md transition-all"
        >
          <FaHeart className="mr-2" />
          Faire un don de 5 €
        </a>
      </div>
    </div>
  );
};

export default ProduitsPage;
